<ng-container *ngIf="dialog$ | async as dialog">
    <div class="modal-header justify-content-start">
        <div class="modal-title">Add Team</div>
    </div>
    <div class="modal-body" [formGroup]="option">
        <div class="row">
            <div class="col-5 text-center">
                <span class="img-label d-block mb-1">Team Image</span>
                <div class="position-relative w-100">
                    <div
                        *ngIf="option.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                    >
                        <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                    </div>
                    <div
                        *ngIf="option.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                    >
                        <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetImage('image')"></app-icon-delete>
                    </div>
                    <img style="border-radius: 5px" class="w-100" [src]="option.controls.imageDataUrl.value">
                </div>
            </div>
            <div class="col-2">
            </div>
            <div class="col-5 text-center">
                <span class="img-label d-block mb-1">Team Cover Image</span>
                <div class="position-relative w-100">
                    <div
                        *ngIf="option.controls.imageCoverDataUrl.value === '/images/blank_2x1.png'"
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                    >
                        <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageCoverFile"></app-input-file>
                    </div>
                    <div
                        *ngIf="option.controls.imageCoverDataUrl.value !== '/images/blank_2x1.png'"
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                    >
                        <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetImage('cover')"></app-icon-delete>
                    </div>
                    <img style="border-radius: 5px" class="w-100" [src]="option.controls.imageCoverDataUrl.value">
                </div>
            </div>
        </div>

        <div class="row mb-4 mt-1">
            <div class="col-5 text-center">
                @if(option.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(0)" class="blue-text body-2">Choose from previously used images</a>
                }
            </div>
            <div class="col-2">
            </div>
            <div class="col-5 text-center">
                @if(option.controls.imageCoverDataUrl.value === '/images/blank_2x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(0, 'cover')" class="blue-text body-2">Choose from previously used images</a>
                }
            </div>
        </div>

      <mdb-form-control class="form-fill">
          <app-mdbp-input mdbInput  formControlName="name" label='Name'></app-mdbp-input>
      </mdb-form-control>
      <span class="error-message body-2"  *ngIf="option.controls.name.touched && option.controls.name.invalid">Please provide name</span>

      <mdb-form-control class="form-fill">
          <app-mdbp-input mdbInput  [isCurrencyMask]="true" label='Goal'>
              <input  #inputNameC formControlName="goal" currencyMask [options]="{'precision': 2}" class="form-control form-control--paybee"/>
          </app-mdbp-input>
      </mdb-form-control>
      <span class="error-message body-2" *ngIf="option.controls.goal.touched && option.controls.goal.errors?.required">Goal required</span>
      <span class="error-message body-2" *ngIf="option.controls.goal.touched && option.controls.goal.errors?.max">Max goal is $400 000</span>

      <div class="position-relative mb-4">
          <label class="form-check-label form-check-label--paybee mb-1 mt-3">Description (optional)</label>
          <mdb-form-control class="mb-4">     
              <app-quill-custom mdbInput formControlName="desc" limit="2048"></app-quill-custom>
          </mdb-form-control>
      </div>
  </div>
  <div class="modal-footer paybee-modal-footer">
      <div class="row">
      <div class="col-4 offset-4">
          <button type="button" class="btn btn--paybee btn--transparent btn--md text-center w-100" (click)="close(false)">Cancel</button>
      </div>
      <div class="col-4">
          <button [ngClass]="imageService.loadingClasses()" type="button" class="btn btn--paybee btn--black btn--md text-center w-100" (click)="confirm(true, option.value)">Confirm</button>
      </div>
      </div>
  </div>  
</ng-container>